import PageContent from "../common/PageContent";
import React, {useEffect, useState} from "react";
import {PluginUtil} from "../../utils/PluginUtil";
import {CommonUtil} from "../../utils/CommonUtil";
import axios from "axios";
import {API} from "../../api/APIClient";

export const PluginGlobalConfig = (props) => {

    const [data, setData] = useState({});
    const [networkInFlight, setNetworkInFlight] = useState(null);

    useEffect(() => {
        fetchConfigFromNetwork();
    }, []);

    function getDataValue(keyName, defaultValue) {
        return CommonUtil.getOrDefault(data, keyName, defaultValue);
    }

    function setDataValue(keyName, value) {
        const newData = CommonUtil.cloneObject(data);
        newData[keyName] = value;
        setData(newData);
    }

    function fetchConfigFromNetwork() {
        if (networkInFlight) return;
        setNetworkInFlight(true);

        axios.get(API.plugin.getPluginGlobalConfig)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    setData(resp.data);
                } else {
                    // Error?
                }
                setNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setNetworkInFlight(false);
                // Error?
            })
    }

    function submitConfigOverNetwork() {
        if (networkInFlight) return;
        setNetworkInFlight(true);

        const itemData = [];

        const dataKeys = Object.keys(data);
        dataKeys.forEach((key) => {
            itemData.push({
                key,
                value : data[key]
            })
        });

        const postData = {
            data : JSON.stringify(itemData)
        }

        axios.post(API.plugin.submitPluginGlobalConfig, postData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    // Report success
                } else {
                    // Error
                }
                setNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setNetworkInFlight(false);
                // TODO Error
            });
    }

    // RENDER

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Plugin", url : "/plugin"},
        {id: 2, title : "Config"}
    ];

    const submitButton = [];
    if (!networkInFlight) {
        submitButton.push(
            <button
                className={"button success"}
                onClick={() => submitConfigOverNetwork()}
            >
                Save
            </button>
        );
    } else {
        submitButton.push(
            <button className={"button secondary"}>
                Please wait
            </button>
        )
    }

    return (
        <PageContent pathElements={pathElements}>
            <div className="grid-x grid-padding-x main-table-head">
                <div className={"cell small-12"}>
                    <h3>Plugin Settings</h3>
                </div>
            </div>

            <div className={"grid-x grid-padding-x section-wrapper table-wrap"}>
                <div className={"cell small-12"}>

                    <div className={"grid-x grid-padding-x"}>
                        <div className={"cell small-12"}>
                            <fieldset className={"fieldset"}>
                                <legend>Privacy Policy</legend>
                                <div className={"cell small-12"}>
                                    <label htmlFor={"privacy-policy-url"}>Privacy Policy URL</label>
                                    <input
                                        type={"text"}
                                        name={"privacy-policy-url"}
                                        value={getDataValue(PluginUtil.configKeys.PRIVACY_POLICY_URL)}
                                        onChange={(e) => {
                                            setDataValue(
                                                PluginUtil.configKeys.PRIVACY_POLICY_URL,
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div className={"grid-x grid-padding-x"}>
                        <div className={"cell small-12"}>
                            <fieldset className={"fieldset"}>
                                <legend>Terms of Use</legend>
                                <div className={"cell small-12"}>
                                    <label htmlFor={"privacy-policy-url"}>Terms of Use URL</label>
                                    <input
                                        type={"text"}
                                        name={"privacy-policy-url"}
                                        value={getDataValue(PluginUtil.configKeys.TERMS_USE_URL)}
                                        onChange={(e) => {
                                            setDataValue(
                                                PluginUtil.configKeys.TERMS_USE_URL,
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div className={"grid-x grid-padding-x"}>
                        <div className={"cell"} style={{ textAlign : "center" }}>
                            {submitButton}
                        </div>
                    </div>

                </div>
            </div>

        </PageContent>
    )

}